import PackagesSearchControlsGCWrapper from './PackagesSearchControlsGCWrapper';

export default PackagesSearchControlsGCWrapper;
